// Generated by LiveScript 1.6.0
var each, reject, sortBy, map, keys, foldl, filter;
each = curry$(function(f, xs){
  var i$, to$, i, results$ = [];
  for (i$ = 0, to$ = xs.length; i$ < to$; ++i$) {
    i = i$;
    f(xs[i]);
    results$.push(xs);
  }
  return results$;
});
reject = curry$(function(f, xs){
  var result, i$, to$, i;
  result = [];
  for (i$ = 0, to$ = xs.length; i$ < to$; ++i$) {
    i = i$;
    if (!f(xs[i])) {
      result.push(xs[i]);
    }
  }
  return result;
});
sortBy = curry$(function(f, xs){
  return xs.slice().sort(function(a, b){
    return f(a) - f(b);
  });
});
map = curry$(function(f, xs){
  var result, i$, to$, i;
  result = [];
  for (i$ = 0, to$ = xs.length; i$ < to$; ++i$) {
    i = i$;
    result.push(f(xs[i]));
  }
  return result;
});
keys = function(it){
  return Object.keys(it);
};
foldl = curry$(function(f, acc, xs){
  var i$, to$, i;
  for (i$ = 0, to$ = xs.length; i$ < to$; ++i$) {
    i = i$;
    acc = f(acc, xs[i]);
  }
  return acc;
});
filter = curry$(function(f, xs){
  var result, i$, to$, i;
  result = [];
  for (i$ = 0, to$ = xs.length; i$ < to$; ++i$) {
    i = i$;
    if (f(xs[i])) {
      result.push(xs[i]);
    }
  }
  return result;
});
module.exports = {
  each: each,
  reject: reject,
  filter: filter,
  sortBy: sortBy,
  map: map,
  keys: keys,
  foldl: foldl
};
function curry$(f, bound){
  var context,
  _curry = function(args) {
    return f.length > 1 ? function(){
      var params = args ? args.concat() : [];
      context = bound ? context || this : this;
      return params.push.apply(params, arguments) <
          f.length && arguments.length ?
        _curry.call(context, params) : f.apply(context, params);
    } : f;
  };
  return _curry();
}